import { FormlyFieldConfig } from "@ngx-formly/core";
import { RichiestaOccupazioneStep } from "../shared/richiesta-occupazione.step";
import { LavoriOccupazioneStep } from "../shared/lavori-occupazione.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";
import { AllegatiScavoStep } from "./steps/allegati-scavo.step";
import { OccupazioneScavoStep } from "./steps/occupazione-scavo.step";


export const Scavo: FormlyFieldConfig[] = [
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
        {
            props: {
                slabel: "DITTE",
                label: "RESPONSABILE DEI LAVORI E DITTE ESECUTRICI",
            },
            wrappers: ['panel-step'],
            fieldGroup: LavoriOccupazioneStep
        },
        {
            props: {
                slabel: "UBICAZIONE",
                label: "UBICAZIONE DEL CANTIERE IN MAPPA",
            },
            wrappers: ['panel-step'],
            fieldGroup: UbicazioneStep
        },
      {
        props: {
            slabel: 'RICHIESTA',
            label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaOccupazioneStep
      },
      {
        props: {
            slabel: 'OCCUPAZIONE',
            label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER SCAVO'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazioneScavoStep
      },
       {
         props: {
            slabel: 'ALLEGATI',
            label: 'DOCUMENTAZIONE ALLEGATA'
        },
         wrappers: ['panel-step'],
         fieldGroup: AllegatiScavoStep
       },
    ]
